import { flattenValues } from '@uniformdev/canvas';
import { type ParameterRichTextValue, isRichTextValueConsideredEmpty } from '@uniformdev/richtext';

import { ValuePropCardData } from '@/libraries/design/patterns/value-props/src/value-prop-card';
import ValueProps, {
	MediaAspectRatio,
} from '@/libraries/design/patterns/value-props/src/value-props';
import { RichTextComponent } from '@/libraries/design/utils';

interface UniformValuePropsProps {
	title: string;
	subtitle?: string;
	cards: ValuePropCardData[];
	mediaAspectRatio?: MediaAspectRatio;
}

type UniformValuePropCardData = ValuePropCardData & {
	richTextDescription?: ParameterRichTextValue;
};

const UniformValueProps = ({
	title,
	subtitle,
	cards,
	mediaAspectRatio,
}: UniformValuePropsProps) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const flattenedCards = flattenValues(cards as any) as UniformValuePropCardData[];
	const renderedCards = flattenedCards.map((card) => ({
		...card,
		description:
			card.richTextDescription && !isRichTextValueConsideredEmpty(card.richTextDescription) ? (
				<RichTextComponent uniformRichText={card.richTextDescription.root} />
			) : (
				card.description
			),
	}));

	return (
		<ValueProps
			title={title}
			subtitle={subtitle}
			cards={renderedCards}
			mediaAspectRatio={mediaAspectRatio}
		/>
	);
};

export default UniformValueProps;
